import { user } from 'utils/auth/user';

export async function initUserlane(language: string, market: string, brand: string): Promise<void> {
  if (user.type === 'dealer') {
    const userlaneAttributes = {
      primaryBrand: brand,
      primaryMarket: market,
      app: `3de`,
    };

    Userlane('identify', user.userPseudonym, userlaneAttributes);
    Userlane('init', '32eqx');
    Userlane('lang', language);
  }
}

export function openUserlane(): void {
  Userlane('openAssistant');
}
